<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text"
        >{{ $t('text.admin').toUpperCase() }} -
        {{ $t('text.algorithms').toUpperCase() }}</span
      >
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <div>
          <div class="section-title mb-20">
            <span>{{ $t('text.urine_conversion_feature') }}</span>
            <span class="right-float">
              <svg-icon
                iconClass="filter"
                className="content-element-color-more-lighter"
              ></svg-icon>
              <el-input
                v-model="urineConversionFeatureFilter"
                size="mini"
                class="search-input filter-input"
                :placeholder="$t('text.filter_by_group_or_users')"
                @keyup.enter.native="getUrineConversionFeatureData()"
              ></el-input>
            </span>
          </div>
          <el-table
            border
            size="mini"
            :data="urine_conversion_feature"
            v-loading="loading"
          >
            <el-table-column :label="$t('text.group')" prop="GroupName">
            </el-table-column>
            <el-table-column :label="$t('text.users')">
              <template slot-scope="scope">
                <div v-if="scope.row.Patients.length">
                  <div v-for="(user, i) in scope.row.Patients" :key="i">
                    {{ user.Alias }}
                  </div>
                </div>
                <div v-else>--</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('text.use_urine_transform')"
              v-if="p('Manage Module.Super Admin.Algorithms.Save')"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.IsUrine"
                  @change="changeGroupStatus(scope.row)"
                ></el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      urineConversionFeatureFilter: '',
      urine_conversion_feature: [],
      loading: false,
      urineTimer: '',
      user: JSON.parse(localStorage.getItem('user')),
      changeSystemRetentionLoading: false
    }
  },
  mounted() {
    this.getUrineConversionFeatureData()
  },
  watch: {
    urineConversionFeatureFilter() {
      if (this.urineTimer) {
        clearTimeout(this.urineTimer)
      }
      this.urineTimer = setTimeout(this.getUrineConversionFeatureData, 500)
    }
  },
  methods: {
    getUrineConversionFeatureData() {
      this.urine_conversion_feature = []
      this.loading = true
      ApiService.GetGroups(this.urineConversionFeatureFilter)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.urine_conversion_feature = response.data.data
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    changeGroupStatus(row) {
      this.loading = true
      ApiService.ChangeGroupStatus(row.GroupId, row.IsUrine)
        .then(response => {
          this.loading = false
          if (!response.data.success) {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.urineTimer)
  }
}
</script>
